<div class="plan-payment-card">
  <umkt-loading [isLoading]="isLoading"></umkt-loading>

  <div *ngIf="!showCardForm" class="card-list-section">
    <umkt-credit-card-list
      [cardsInfo]="cardsInfo"
      (cardSelected)="onCreditCardSelected($event)"
      [selectedCardToken]="selectedCardId"
    ></umkt-credit-card-list>
  </div>

  <form [formGroup]="creditCardForm" *ngIf="showCardForm" class="new-card-form">
    <p class="section-title">{{ 'pages.paymentCard.title' | i18n }}</p>
    
    <umkt-input-credit-card-number 
      formControlName="cardNumber"
      (cardFlagChange)="onCardFlagChange($event)">
    </umkt-input-credit-card-number>

    <div class="input-group">
      <ustore-input
        [placeholder]="'pages.paymentCard.form.cardHolder.placeholder' | i18n"
        formControlName="cardHolder"
        [clearable]="false"
        maxlength="64"
        (input)="onCardNameInput($event)"
        (keydown)="blockLeadingSpace($event)"
      ></ustore-input>

      <div *ngIf="creditCardForm.get('cardHolder')?.errors && creditCardForm.get('cardHolder')?.touched" class="field-error">
        {{ creditCardForm.get('cardHolder') | validationMessage }}
      </div>
    </div>

    <div class="row-group">
      <div class="input-group">
        <ustore-input
          [placeholder]="'pages.paymentCard.form.expiryDate.placeholder' | i18n"
          formControlName="cardExpirationDate"
          [clearable]="false"
          (input)="onExpiryDateInput($event)"
        >
        </ustore-input>
        <div *ngIf="creditCardForm.get('cardExpirationDate')?.errors && creditCardForm.get('cardExpirationDate')?.touched" class="field-error">
          {{ creditCardForm.get('cardExpirationDate') | validationMessage }}
        </div>
      </div>

      <div class="input-group">
        <ustore-input
          [placeholder]="'pages.paymentCard.form.cvc.placeholder' | i18n"
          formControlName="cardSecurityCode"
          [clearable]="false"
          maxlength="4"
          (input)="onCvcInput($event)"
        >
        </ustore-input>
        <div *ngIf="creditCardForm.get('cardSecurityCode')?.errors && creditCardForm.get('cardSecurityCode')?.touched" class="field-error">
          {{ creditCardForm.get('cardSecurityCode') | validationMessage }}
        </div>
      </div>
    </div>

    <div class="input-group">
      <ustore-input
        [placeholder]="'pages.paymentCard.form.cnpj.placeholder' | i18n"
        formControlName="document"
        [clearable]="false"
        maxlength="18"
        (input)="onCnpjInput($event)"
        (paste)="onCnpjPaste($event)"
      ></ustore-input>

      <div *ngIf="creditCardForm.get('document')?.errors?.['invalidCNPJ'] && creditCardForm.get('document')?.touched" class="field-error">
        {{ 'pages.paymentCard.form.cnpj.errorInvalid' | i18n }}
      </div>
    </div>

    <div class="button-group">
      <button type="button" class="btn-outline" (click)="onCancelCard()">
        {{ 'shared.buttons.cancel' | i18n }}
      </button>
      <button type="button" class="btn-primary" (click)="onRegisterCard()" [disabled]="!creditCardForm.valid">
        {{ 'pages.paymentCard.buttons.register' | i18n }}
      </button>
    </div>
  </form>
</div>